// @vendors
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @components
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const CardsCancelPayLaterError = require('components/cards/cardsCancelPayLater/cardsCancelPayLaterError');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardsCancelPayLaterSuccess = require('components/cards/cardsCancelPayLater/cardsCancelPayLaterSuccess');
const CardsCancelPayLaterWizard = require('components/cards/cardsCancelPayLater/cardsCancelPayLaterWizard');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @actions
const CardCancelPayLaterActions = require('actions/cardsCancelPayLater');
const { getCreditCardPayLaterOptedInfo } = require('actions/creditCardPayLaterInfo')

// @utilities
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');

class CardsCancelPayLaterView extends React.Component {

    constructor(props) {
        super(props);
        this.onFinish = this.onFinish.bind(this);
    }

    componentDidMount() {
        const { immCards, match: { params: { cardId } }, flagBasedFeatures, history, immCardCancelPayLaterInfo } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const cancelPayLaterEnabled = flagBasedFeatures.get('card-cancel-pay-later-enabled');
        if (immCardCancelPayLaterInfo.get('payLaterData').size == 0 || !cancelPayLaterEnabled) {
            history.push(`/myprofile/cards/${cardId}/movements`);
        }
        if (cardValidationRules.CARD_PAY_LATER.validator({ immCard })) {
            this.props.getCreditCardPayLaterOptedInfo(immCard);
        }
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }

    onFinish() {
        const { match: { params: { cardId } }, finish } = this.props;
        finish(cardId);
    }

    buildSuccess() {
        const { immCardCancelPayLaterInfo, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        return (
            <CardsCancelPayLaterSuccess
                cardId={cardId}
                immCard={immCard}
                immCardCancelPayLaterInfo={immCardCancelPayLaterInfo}
            />
        );
    }

    buildWizard() {
        const {
            immAccounts,
            immCards,
            immCardCancelPayLater,
            immCardCancelPayLaterInfo,
            onValidateStep,
            onWillCancel,
            match: { params: { cardId, movementId } },
            reset,
            setVisibleStep,
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        return (
            <CardsCancelPayLaterWizard
                immCard={immCard}
                cardId={cardId}
                immAccounts={immAccounts}
                immCardCancelPayLater={immCardCancelPayLater}
                immCardCancelPayLaterInfo={immCardCancelPayLaterInfo}
                movementId={movementId}
                finish={this.onFinish}
                onValidateStep={onValidateStep}
                onWillCancel={onWillCancel}
                reset={reset}
                setVisibleStep={setVisibleStep}
            />
        );
    }

    render() {
        const {
            immCardCancelPayLater,
            immCards,
            immCardSecurePayment,
            match: { params: { cardId } },
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        let content;
        const immSteps = this.props.immCardCancelPayLater.get('steps');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.getIn(['alias', 'current']),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardCancelPayLater-cardCancelPayLater_breadcrumbText'),
                url: ''
            }
        ];

        if (immCardCancelPayLater.get('submitSuccessful')) {
            content = this.buildSuccess();
        }
        else if (immCardCancelPayLater.get('error')) {
            content = (<CardsCancelPayLaterError
                cardId={cardId}
                immCard={immCard}
            >
            </CardsCancelPayLaterError>)
        }
        else {
            content = (
                <div className="row grid-view--content-position-negative">
                    <div className="col-xs-12 col-md-8">
                        {this.buildWizard()}
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <div className="row">
                            <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                                <CardDetailsSidebar
                                    immCard={immCard}
                                    immCardSecurePayment={immCardSecurePayment}
                                    immSteps={immSteps}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        let headerText = (<FormattedText value="cardsCancelPayLater-cardsCancelPayLater_pageTitle" />)
        const type = immCard.get('type');
        const subtitleLeft = formatText(`cards-${type}`);
        const subtitleRight = immCard.get('alias').get('current');

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="cards" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                subtitleRight={subtitleRight}
                                finalTitle={headerText}
                            >
                                <CardHeaderDetails
                                    immCard={immCard}
                                    rightSpace={true}
                                />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    {content}
                </div>
            </div>
        );
    }
}

CardsCancelPayLaterView.propTypes = {
    finish: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    getCreditCardPayLaterOptedInfo: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardCancelPayLater: PropTypes.object.isRequired,
    immCardCancelPayLaterInfo: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardSecurePayment: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onWillCancel: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
};

module.exports.constructor = CardsCancelPayLaterView;
module.exports.CardsCancelPayLaterView = connect(
    (state) => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immCardCancelPayLater: state.cardsCancelPayLater,
        immCardCancelPayLaterInfo: state.creditCardPayLaterInfo,
        immCards: state.cards,
    }),
    {
        finish: CardCancelPayLaterActions.finish,
        getCreditCardPayLaterOptedInfo: getCreditCardPayLaterOptedInfo,
        onValidateStep: CardCancelPayLaterActions.validateStep,
        onWillCancel: CardCancelPayLaterActions.setWillCancel,
        reset: CardCancelPayLaterActions.reset,
        setVisibleStep: CardCancelPayLaterActions.setVisibleStep,
    }
)(withRouter(CardsCancelPayLaterView));
